export default "__VITE_ASSET__BJpdBLf3__"